import './spinner.css';
import spinnerImg from './claro-spritesheet.png'
import React  from 'react';
import PropTypes from 'prop-types';
import {removeDynamicFocus} from "../Focus/utils";

const Spinner = ({className, loadingMessage}) => {
  const classM = className ? className : '';

  setTimeout(()=>{
    removeDynamicFocus();
  },0)

  return (
    <div className={`spinner-container ${classM}`} >
      <div className="spinner" style={{background:`url('${spinnerImg}') left center`}}/>
      {loadingMessage && <div id='spinner-percentage'/>}
    </div >
  )
};

Spinner.propTypes = {
  classM: PropTypes.string,
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/index.jsx